import * as ThemeManager from './ThemeManager';

export function LargeDeviceOnly({ children }: React.PropsWithChildren) {
	return ThemeManager.isLargeDevice() ? children : null;
}